'use client';

import React, { type FC } from 'react';
import { RouterLink } from '@paypoteam/page-components';
import { AccordionRoot } from '@paypoteam/ui-components';
import Link from 'next/link';

import { cn } from '@/lib/utils';

import type { MobileAccordionProps } from './components/MobileAccordion';
import { MobileAccordion } from './components/MobileAccordion';

import type { NavListProps } from '@/types';

interface MobileNavigationListProps
    extends NavListProps,
        Omit<MobileAccordionProps, 'data'> {
    accordionClassName?: string;
}

const MobileNavigationList: FC<MobileNavigationListProps> = ({
    links,
    location,
    className,
    handleMenuClose,
    accordionClassName,
    ...props
}) => (
    <AccordionRoot
        type="single"
        collapsible
    >
        <ul className={cn('w-full', className)}>
            {links.map((item, i) =>
                !!item.menu ? (
                    <li key={`${item.menu.list[0]?.href}_${i}`}>
                        <MobileAccordion
                            data={item}
                            handleMenuClose={handleMenuClose}
                            location={location}
                            className={accordionClassName}
                            {...props}
                        />
                    </li>
                ) : (
                    <li
                        key={`${item.href}_${i}`}
                        className="text-md"
                    >
                        <RouterLink
                            // @ts-ignore @TODO change types in lib page-components
                            LinkElement={Link}
                            onClick={() => {
                                // Sentry.addBreadcrumb({
                                //     category: 'navigation',
                                //     message: 'click to menu link ' + item.href,
                                //     level: 'info',
                                // });

                                handleMenuClose && handleMenuClose();
                            }}
                            linkData={item}
                            className={'py-3'}
                            variant={{
                                color:
                                    item.href === location
                                        ? 'active'
                                        : 'primary',
                                states: 'enable',
                            }}
                        />
                    </li>
                ),
            )}
        </ul>
    </AccordionRoot>
);

export default MobileNavigationList;
